import { ReactElement } from "react";
import styles from "./style.module.scss";
import Form from "@components/shared/form";
import colors from "@styles/variables/carinjuryjusticeVariables.module.scss";
import { useDomainContext } from "@hooks/useDomainContext";
import { useRouter } from "next/router";
import { finalShowForm } from "@lib/sharedUtils";
import TextBlockOffer from "@components/shared/textBlockOffer/TextBlockOffer";

export default function ServiceForm(): ReactElement {
    const router = useRouter();
    const { category, domain } = useDomainContext();
    const isFormDisplayed = finalShowForm(
        router.query.sl as string,
        domain.showForm,
        domain.defaultOffers,
    );

    return (
        <>
            {isFormDisplayed ? (
                <div
                    className={`${styles.mainBanner} ${
                        styles[category?.slug as string]
                    } `}
                >
                    <div className={`${styles.formWrapper} py-10`}>
                        <div>
                            <Form
                                classes={{
                                    formClassName: `${styles["form"]}`,
                                    stepTitleClassName: styles["step-title"],
                                    stepClassName: styles["step-block"],
                                    stepDescriptionClassName:
                                        styles["step-description"],
                                    formButtonClassName: styles["form-button"],
                                    formFieldClassName: styles["form-field"],
                                    formFieldLabelClassName:
                                        styles["field-label"],
                                    formStepInnerClassName:
                                        styles["steps-inner"],
                                    fieldsClassName: {
                                        radio: styles["radio-field"],
                                    },
                                    fieldsWrapperClassName:
                                        styles["fields-wrapper"],
                                    tcpaClassName: styles["tcpa"],
                                    labelAsTitleClassName:
                                        styles["label-as-step-title"],
                                    formSubmitButtonClassName:
                                        styles["submit-button"],
                                    sellingPointClassName:
                                        styles["selling-point"],
                                    formProgressbarClassName:
                                        styles["custom-progress"],
                                }}
                                colors={{
                                    primaryColor: colors.lcPrimary,
                                }}
                                showProgress={true}
                                backButton={{
                                    class: styles["back-button"],
                                    label: "Back",
                                }}
                                preventWindowClose
                                popupStyle={{
                                    iconColor: colors.mainColor,
                                    actionBtnBgColor: colors.mainColor,
                                }}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <TextBlockOffer />
            )}
        </>
    );
}
